module.exports = __webpack_public_path__ + "img/kitchen.3170dc2b.svg";